/****************************************************
 * Module Name:  lotCreationMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Constants from "../../../utility/constants";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, FormControlLabel, Tooltip, Switch, Typography, } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../../common/dataGridCellExpand";
import Utility from "../../../utility/utility";
import CommonSnackbar from "../../common/commonSnackBar";
import LotCreationProxy from "../../../utility/proxy/manager/manufacturingProxy/lotCreationProxy";
import AddLotCreationModal from "./addLotCreationModal";
import NoPermission from "../../common/noPermission";
import { styled, } from "@mui/material/styles";
import AddLot from "./addLot";
import LotDetailModal from "./lotDetailModal";
import { MdCallSplit } from "react-icons/md";
import LotSplitModal from "./lotSplitModal";
import PageTitle from "../../common/pageTitle";

const LotSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export class LotCreationMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lotcreation: [],
      showAddLotCreationModal: false,
      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      errorMessage: "",
      snackbarVariant: "",
      loadingButton: false,
      allocatedLot: false,
      accesDenied: false,
      showLotCreationLoadSpinner: true,
      showAddLotModal: false,
      filterValues: {},
      showLotDetailsModal: false,
      lotid: "",
      totalLots: 0,
      rowData: {},
      totalPendingLots: 0,
      totalCarats: 0,
      totalPendingCarats: 0,
      totalPendingPrice: 0,
      columnNames: [],
      showLotSplitModal: false,
      local_Permission: Constants.USER_PERMISSION.filter((iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTCREATION),
      lotDetailPermission: Constants.USER_PERMISSION.filter(iPermission =>
        iPermission.permissionid === Constants.PERMISSIONS.LOTDETAIL),
      showSnackbar: false,
      snackbarMessage: ""
    };
    this.checkPermission();
  }

  componentDidMount() {
    PageTitle("MANUFACTURING_OPERATION_LOTCREATION");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchLotCreationData(false, this.state.allocatedLot);
    }
  }

  fetchLotCreationData = (bAnimateSpinner, fetchAll) => {
    bAnimateSpinner && this.setState({ showLotCreationLoadSpinner: true });
    fetchAll
      ? LotCreationProxy.GetAllLotCreation((responseData) => {
        if (responseData) {
          const uniqueFilterValues = {
            companyname: Utility.getDistinctOptions(responseData, "companyname"),
            currencytype: Utility.getDistinctOptions(responseData, "currencytype"),
          };
          this.setState({
            filterValues: uniqueFilterValues,
            lotcreation: responseData,
            showLotCreationLoadSpinner: false,
          })
          this.getSummaryReport(responseData);
          this.prepareColumns(uniqueFilterValues);
        } else {
          this.setState({
            showLotCreationLoadSpinner: false,
            errorSnackbar: true,
            errorMessage: Constants.APiFailErrorMessage,
            snackbarVariant: "error",
          });
        }
      })
      : LotCreationProxy.GetAllLotCreationByPendingWeight((responseData) => {
        if (responseData) {
          const uniqueFilterValues = {
            companyname: Utility.getDistinctOptions(responseData, "companyname"),
            currencytype: Utility.getDistinctOptions(responseData, "currencytype"),
          };
          this.setState({
            filterValues: uniqueFilterValues,
            lotcreation: responseData,
            showLotCreationLoadSpinner: false,
          })
          this.getSummaryReport(responseData);
          this.prepareColumns(uniqueFilterValues);
        } else {
          this.setState({
            showLotCreationLoadSpinner: false,
            errorSnackbar: true,
            errorMessage: Constants.APiFailErrorMessage,
            snackbarVariant: "error",
          });
        }
      }
      );
  };

  getSummaryReport = (data) => {
    if (!Array.isArray(data)) return;
    let totalLots = data.length;
    let totalLotsWithPendingWeight = 0;
    let carats = 0;
    let pendingcarats = 0;
    let pendingLotPrice = 0;
    data.forEach((item) => {
      totalLotsWithPendingWeight += item.pendingcarats ? 1 : 0;
      carats += item.carats;
      pendingcarats += item.pendingcarats;
      pendingLotPrice += item.pendingcarats * item.price;
    });

    this.setState({
      totalLots: totalLots,
      totalPendingLots: totalLotsWithPendingWeight,
      totalCarats: carats,
      totalPendingCarats: pendingcarats,
      totalPendingPrice: pendingLotPrice,
    });
  }


  prepareColumns = (uniqueFilterValues) => {
    const columnNames = this.columnsWithoutPermission.map(woPermissionColumn => {
      let guids = [];

      // Determine which GUIDs (permissions) should be added based on the column field
      switch (woPermissionColumn.field) {
        case "companyname":
          guids = [
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_CREATEDAT,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_DATE_RECEIVED,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_INVOICEDATE,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_INVOICENO,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_PAYMENTDATE,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_PAYMENTDAYS,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_CURRENCYTYPE,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_CURRENCYRATE,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_PCS,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_CARATS,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_PENDING_CARATS,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_PRICE,
            Constants.COLUMN_PERMISSION.MFG_LOT_CRTN_TOTAL,
          ];
          break;
        default:
          guids = [];
      }

      // Retrieve valid permission columns
      return this.fetchColumnDataFromGuid(guids, woPermissionColumn, this.columnsWithPermission, uniqueFilterValues);

    }).flat(); // Flatten the array

    // Update state with the prepared columns
    this.setState({
      columnNames: columnNames
    })
  };

  fetchColumnDataFromGuid = (guids, currentColumn, columnsWithPermission, uniqueFilterValues) => {
    const permissionColumns = guids
      .map(id => Constants.USER_COLUMN_PERMISSION.find(permission => permission === id)) // Match permissions
      .filter(Boolean) // Remove undefined values (invalid permissions)
      .map(guid => {
        const columnData = columnsWithPermission[guid]; // Get column details

        // If the columnData is missing or an empty object, skip adding it
        if (!columnData || Object.keys(columnData).length === 0) {
          return null;
        }

        // Retrieve unique filter values for the column, defaulting to an empty array
        const filterData = uniqueFilterValues[columnData.field] || [];

        return {
          ...columnData,  // Copy all existing column properties
          valueOptions: filterData,  // Assign filter values
        };
      })
      .filter(Boolean); // Remove any null values from the list

    // Modify the original column before adding it to the list
    const modifiedColumn = {
      ...currentColumn,  // Retain original column properties
      valueOptions: uniqueFilterValues[currentColumn.field] || [], // Assign filter values
    };

    // Return an array with the modified column and any valid permission columns
    return [modifiedColumn, ...permissionColumns];
  };

  columnsWithPermission = {
    "25c97def-d08f-4d8c-a102-34030a9adea3": {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.value),
    },
    "87533f90-57b8-4c2b-ab39-e1aefe67e778": {
      field: "datereceived",
      headerName: "RECEIVED AT",
      headerAlign: "center",
      align: "center",
      width: 140,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => {
        if (params.value) {
          return Utility.ConvertUtcToLocalDate(params.value);
        } else {
          return "";
        }
      }
    },
    "a143d68e-af99-46ca-b6b0-6482a8e5016d": {
      field: "invoicedate",
      headerName: "INVOICE DATE",
      headerAlign: "center",
      align: "center",
      width: 140,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => {
        if (params.value) {
          return Utility.ConvertUtcToLocalDate(params.value);
        } else {
          return "";
        }
      }
    },
    "8248ba1c-0f49-4f7c-800a-13edbc2241f2": {
      field: "invoiceno",
      headerName: "INVOICE NO",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "d3863ef4-fc1c-4d4c-9cd6-a1400ff58656": {
      field: "paymentdate",
      headerName: "PAYMENT DATE",
      headerAlign: "center",
      align: "center",
      width: 140,
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => {
        if (params.value) {
          return Utility.ConvertUtcToLocalDate(params.value);
        } else {
          return "";
        }
      }
    },
    "b1c7d54c-b4ba-425a-a892-257d2bfab704": {
      field: "paymentdays",
      headerName: "PAYMENT DAYS",
      headerAlign: "center",
      align: "center",
      width: 140,
      type: 'number',
      renderCell: renderCellExpand,
    },
    "8d8dda62-47da-46fd-93c6-5cada9f5a8d6": {
      field: "currencytype",
      headerName: "CURRENCY TYPE",
      headerAlign: "center",
      align: "center",
      width: 130,
      type: "singleSelect",
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "065564c6-3a09-4529-bbfd-ade603791451": {
      field: "currencyrate",
      headerName: "CURRENCY RATE",
      headerAlign: "center",
      align: "center",
      width: 130,
      type: 'number',
      renderCell: renderCellExpand,
    },
    "1a7ee27e-693c-45b0-8efe-f5a5df49a9a5": {
      field: "pcs",
      headerName: "PCS",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: 'number',
      renderCell: renderCellExpand,
    },
    "1ed2e58e-50c7-4229-bae3-bebb85e70722": {
      field: "carats",
      headerName: "CTS",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: 'number',
      renderCell: renderCellExpand,
    },
    "242b96e4-098c-48ef-bbee-31263e0ffe12": {
      field: "pendingcarats",
      headerName: "PENDING CTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      type: 'number',
    },
    "db5cef10-f033-4f81-8423-526453b57e5f": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      type: 'number',
      width: 120,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "af9588fb-1eea-4665-8b49-c1da35bbdfc7": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "center",
      type: 'number',
      width: 120,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
    },

  };

  columnsWithoutPermission = [
    {
      field: "lotcreationid",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: 'number',
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.isReadAllowed(this.state.lotDetailPermission) ?
        (<Button
          sx={{
            textDecorationLine: "underline",
            color: 'black'
          }}
          onClick={() => this.setState({ showLotDetailsModal: true, lotid: params.value })}
        >
          {params.value}
        </Button>) : <div>{params.value}</div>,
    },
    {
      field: "lotintimationid",
      headerName: "LOT INT ID",
      headerAlign: "center",
      align: "center",
      width: 90,
      type: 'number',
      renderCell: renderCellExpand,
    },
    {
      field: "companyname",
      headerName: "COMPANY NAME",
      headerAlign: "center",
      align: "center",
      width: 200,
      type: "singleSelect",
      filterOperators: Utility.combinedFilters(),
    },
    {
      field: "lotprice",
      headerName: "LOT PRICE",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: 'number',
      renderCell: (params) =>
        (Number(params.row.carats) * Number(params.row.price)).toFixed(2),
    },
    {
      field: "pendinglotprice",
      headerName: "PENDING LOT PRICE",
      headerAlign: "center",
      align: "center",
      width: 200,
      type: 'number',
      renderCell: (params) =>
        (Number(params.row.pendingcarats) * Number(params.row.price)).toFixed(
          2
        ),
    },
    {
      field: "lotsplit",
      headerName: "LOT SPLIT",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: (params) => params.row.pendingcarats > 0 ?
        (<Button
          startIcon={<MdCallSplit />}
          variant="contained"
          onClick={() => this.setState({ showLotSplitModal: true, rowData: params.row })}
        >
          Split
        </Button>) : " - ",
    },
  ];

  hideAddLotCreationModal = () => {
    this.setState({
      showAddLotCreationModal: false,
    });
  };

  handleValidation = (lotCreationData) => {
    //TODO do validation if needed here
    return true;
  };

  addLotCreation = (lotCreationData) => {
    this.setState({ loadingButton: true });
    //Creating new LotCreation, and once lotCreation is created on call refresh the list of current lotcreation
    LotCreationProxy.AddLotCreation(lotCreationData, (response) => {
      if (response) {
        this.fetchLotCreationData(true, this.state.allocatedLot);
        this.setState({
          loadingButton: false,
          showAddLotCreationModal: false
        });
        this.setSnackbar(true, response.errorMessage, response.status);
      } else {
        this.setState({
          loadingButton: false,
          showAddLotCreationModal: false
        });
        this.setSnackbar(true, Constants.APiFailErrorMessage, "error");
      }
    });
  };

  splitLot = (data) => {
    this.setState({ loadingButton: true });
    LotCreationProxy.SplitLotInToMultipleLots(data, Constants.loggedInUser.id, response => {
      if (response) {
        this.setState({
          loadingButton: false,
          showLotSplitModal: false,
        })
        this.setSnackbar(true, "Lot split into multiple lots successfully", "success");
        this.fetchLotCreationData(false, this.state.allocatedLot);
      } else {
        this.setState({
          loadingButton: false,
          showLotSplitModal: false,
        })
        this.setSnackbar(true, Constants.APiFailErrorMessage, "error");
      }
    })
  }

  setSnackbar = (showSnackbar, snackbarMesage, snackbarVariant) => {
    this.setState({
      showSnackbar: showSnackbar,
      snackbarMessage: snackbarMesage,
      snackbarVariant: snackbarVariant
    })
  }

  hideAddLotModal = () => {
    this.setState({
      showAddLotModal: false,
    });
  };

  addLot = (kapanCreationData) => {
    this.setState({ loadingButton: true });
    //Creating new KapanCreation, and once kapanCreation is created on call refresh the list of current kapanCreations
    LotCreationProxy.AddLotCreationViaMultipleLots(kapanCreationData, Constants.loggedInUser.id, (response) => {
      if (response) {
        this.fetchLotCreationData(true, this.state.status);
        this.setState({
          loadingButton: false,
          showAddLotModal: false
        });
        this.setSnackbar(true, response.errorMessage, response.status);
      } else {
        this.setState({
          loadingButton: false,
          showAddLotModal: false
        });
        this.setSnackbar(true, Constants.APiFailErrorMessage, "error");
      }
    });
  };

  render() {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.lotcreation;
    const columns = Utility.isReadAllowed(this.state.local_Permission) ?
      this.state.columnNames :
      this.state.columnNames.filter(col => col.field !== "lotsplit");

    return (
      <Box className="background">
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{this.state.errorMessage}</Box>}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title={
            this.state.snackbarVariant === "success" ? "Success" : "Failed"
          }
        />

        <CommonSnackbar
          show={this.state.showSnackbar}
          message={this.state.snackbarMessage}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ showSnackbar: false })}
          title={this.state.snackbarVariant === "success" ? "Success" :
            (this.state.snackbarVariant === "error" ? "Failed" : "Warning")}
        />

        {this.state.showAddLotModal ? (
          <AddLot
            show={this.state.showAddLotModal}
            handleClose={this.hideAddLotModal}
            handleSave={this.addLot}
            handleValidation={this.handleValidation}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}

        {this.state.showAddLotCreationModal ? (
          <AddLotCreationModal
            Show={true}
            handleClose={this.hideAddLotCreationModal}
            handleSave={this.addLotCreation}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : null}

        {this.state.showLotDetailsModal ? (
          <LotDetailModal
            lotid={this.state.lotid}
            handleClose={() => this.setState({ showLotDetailsModal: false })}
          />
        ) : null}

        {this.state.showLotSplitModal ? (
          <LotSplitModal
            rowData={this.state.rowData}
            handleClose={() => this.setState({ showLotSplitModal: false })}
            loading={this.state.loadingButton}
            splitLot={this.splitLot}
          />
        ) : null}

        <Box px={1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              py: 2,
              color: "black",
              width: "100%",
              fontWeight: 'normal',
              fontSize: Constants.defaultTableFontSize
            }}

          ><p style={{ margin: 0 }}>
              <span>Total Lots:</span> <b>{this.state.totalLots}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
              <span>Total Pending Lots: </span> <b>{this.state.totalPendingLots}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
              <span>Total Weight: </span> <b>{this.state.totalCarats.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
              <span>Total Pending Weight: </span> <b>{this.state.totalPendingCarats.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
              <span>Total Pending Lot Price: </span> <b>{this.state.totalPendingPrice.toFixed(2)}</b></p>
          </Box>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              // marginTop: "50px",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "77vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="standard"
              slots={{ toolbar: GridToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.lotcreationid}
              loading={this.state.showLotCreationLoadSpinner}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                    locationid: false,
                  },
                },
                pinnedColumns: { right: ["lotsplit"] },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
                sorting: {
                  sortModel: [{ field: "datereceived", sort: "desc" }],
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
            <Box style={{ position: "absolute", top: 5, left: "464px", display: "flex", alignItems: "center", }}>
              <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} gap="10px"
                sx={{
                  "& .MuiFormControlLabel-root": {
                    margin: 0
                  },
                  "& .MuiSwitch-root": {
                    width: "38px",
                    height: "22px"
                  },
                  "& .MuiSwitch-thumb": {
                    width: "18px !important",
                    height: "18px !important"
                  }
                }}
              >
                <FormControlLabel
                  control={<LotSwitch />}
                  onChange={() => {
                    this.setState({
                      allocatedLot: !this.state.allocatedLot,
                    });
                    this.fetchLotCreationData(true, !this.state.allocatedLot);
                  }}
                  checked={this.state.allocatedLot}
                />
                <Typography
                  align="center"
                  variant="h6"
                > Allocated Lot</Typography>
              </Box>
            </Box>

            <Box style={{ position: "absolute", top: 5, right: "270px", display: "flex", alignItems: "center", gap: "10px" }}>

              {this.state.showLotCreationLoadSpinner ? (
                <CircularProgress size="25px" />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    color="primary"
                    fontSize="medium"
                    onClick={() => this.fetchLotCreationData(true, this.state.allocatedLot)}
                    sx={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
              {Utility.isAddAllowed(this.state.local_Permission) ? (
                <Tooltip title="Lot Creation">
                  <Button
                    color="info"
                    variant="outlined"
                    size="small"
                    sx={{ ml: "5px" }}
                    onClick={() =>
                      this.setState({
                        showAddLotModal: true,
                        editOperation: false,
                        sourceData: {},
                        loadingButton: false,
                      })
                    }
                    startIcon={<AddBoxOutlinedIcon size="large" />}
                  >
                    Lot Creation
                  </Button>
                </Tooltip>
              ) : null}
              {Utility.isAddAllowed(this.state.local_Permission) ? (
                <Tooltip title="Receive lot">
                  <Button
                    color="info"
                    variant="outlined"
                    size="small"
                    sx={{ ml: "5px", height: "32px" }}
                    onClick={() =>
                      this.setState({
                        showAddLotCreationModal: true,
                        editOperation: false,
                        sourceData: {},
                        loadingButton: false,
                      })
                    }
                    startIcon={<AddBoxOutlinedIcon size="large" />}
                  >
                    RECEIVE LOT
                  </Button>
                </Tooltip>
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box >
    );
  }
}

export default LotCreationMaster;
